import { SelectorModel } from '../models/table-column.model';
import { TranslateService } from '@ngx-translate/core';

export class UtilsHelper {
  // selector could be just ['address'], but also ['address.street', 'address.postcode']
  static getDataOfSelector(
    selector: SelectorModel[] | null | undefined,
    data: any,
    selectorIsId: boolean = false,
    translate: TranslateService,
    optionalSelector?: SelectorModel[] | null
  ): string {
    // id override
    if (selectorIsId) {
      selector = [{ selector: 'id' }];
    }

    const trySelectors = (sels: SelectorModel[] | null | undefined): string | null => {
      if (!sels) return null;

      let result = '';

      for (const s of sels) {
        let layer = s.selector.split('??');
        let selectorResult: any;

        for (const l of layer) {
          let splits = l.split('.');
          selectorResult = data;
          for (const sp of splits) {
            if (!selectorResult) {
              selectorResult = null;
              break;
            }
            selectorResult = selectorResult[sp];
          }
          if (selectorResult) break;
        }

        if (selectorResult == null || selectorResult == undefined) {
          selectorResult = '';
        }

        if (s.isBoolean) {
          if (selectorResult === true) {
            result += translate.instant(s.booleanTrueText ?? 'YES');
          } else {
            if (s.booleanFalseText === '')
              result += '';
            else
              result += translate.instant(s.booleanFalseText ?? 'NO');
          }
        } else if (s.castFunction) {
          result += translate.instant(s.castFunction(selectorResult));
        } else {
          result += selectorResult;
        }

        if (s.suffix) result += s.suffix;
      }

      return result;
    };

    // 1. Try main selector
    let mainResult = trySelectors(selector);
    if (mainResult !== null && mainResult !== undefined && mainResult.trim() !== '') {
      return mainResult;
    }

    // 2. Fallback to optionalSelector if available
    let optionalResult = trySelectors(optionalSelector);
    if (optionalResult !== null && optionalResult !== undefined && optionalResult !== '') {
      return optionalResult;
    }

    // 3. Default fallback
    return '-';
  }
}
